module.exports = __webpack_public_path__ + "img/gongxiaoLOGO.f3554f52.png";